// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/TeacherPdp/teacher-pdp-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/images/TeacherPdp/mobile-teacher-pdp.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdp_banner .banner_img img:first-child {
  display: block;
  position: relative;
  right: 150px;
  width: 130%;
}

.pdp_banner {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  height: 550px;
  padding: 0 13%;
}

.pdp_banner h1::after {
  content: "";
  position: absolute;
  height: 10px;
  border-radius: 10px;
  width: 50%;
  background: #6f5aca;
  bottom: -15px;
  left: 0px;
}

.pdp_banner span {
  font-size: 48px;
  font-weight: 500;
}

.pdp_banner h1 {
  position: relative;
  color: #112f48;
  line-height: 1.3;
  margin-bottom: 20px;
  font-weight: 800;
  text-transform: uppercase;
}

.pdp_banner_subtxt {
  font-size: 48px;
  font-weight: 600;
}

@media (max-width: 576px) {
  .pdp_banner .banner_img img:first-child {
    display: none;
  }
  .pdp_banner {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    height: 450px;
  }
  .banner_btn {
    font-size: 14px;
    padding: 5px 20px;
  }
  .pdp_banner h1 {
    font-size: 28px;
    text-align: left;
    padding: 0px;
  }
  .pdp_banner h1::after {
    height: 4px;
    bottom: -7px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/TeacherPdp/Banner.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mDAA2E;EAC3E,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,mDAA4E;IAC5E,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".pdp_banner .banner_img img:first-child {\n  display: block;\n  position: relative;\n  right: 150px;\n  width: 130%;\n}\n\n.pdp_banner {\n  background: url(\"../../../public/images/TeacherPdp/teacher-pdp-banner.jpg\");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  display: flex;\n  align-items: center;\n  height: 550px;\n  padding: 0 13%;\n}\n\n.pdp_banner h1::after {\n  content: \"\";\n  position: absolute;\n  height: 10px;\n  border-radius: 10px;\n  width: 50%;\n  background: #6f5aca;\n  bottom: -15px;\n  left: 0px;\n}\n\n.pdp_banner span {\n  font-size: 48px;\n  font-weight: 500;\n}\n\n.pdp_banner h1 {\n  position: relative;\n  color: #112f48;\n  line-height: 1.3;\n  margin-bottom: 20px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.pdp_banner_subtxt {\n  font-size: 48px;\n  font-weight: 600;\n}\n\n@media (max-width: 576px) {\n  .pdp_banner .banner_img img:first-child {\n    display: none;\n  }\n  .pdp_banner {\n    background: url(\"../../../public/images/TeacherPdp/mobile-teacher-pdp.jpeg\");\n    background-size: cover;\n    height: 450px;\n  }\n  .banner_btn {\n    font-size: 14px;\n    padding: 5px 20px;\n  }\n  .pdp_banner h1 {\n    font-size: 28px;\n    text-align: left;\n    padding: 0px;\n  }\n  .pdp_banner h1::after {\n    height: 4px;\n    bottom: -7px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
